<template>
  <b-row>
    <b-modal ref="openModal" class="localizationModal" scrollable size="lg" title="Comentário" @hide="onModalHide"
      @show="onModalShow">
      <h1>Comentários</h1>
      <!-- {{ canComment }} -->
      <!-- {{ newComment }} -->
      <stage-new-comment v-if="canComment" :filledId="filledId" :stageId="stageId" :newComment.sync="newComment"
        @onConfirm="getAllComments"></stage-new-comment>

      <div v-if="comments.length == 0" class="mt-4">
        <label>Nenhum comentário feito para esse processo</label>
      </div>
      <div v-else class="mt-4">
        <div v-for="comment in comments" :key="comment.key">
          <div>
            <div class="comment-title">
              <b> {{ comment.userName }} </b>
              <span> {{ comment.dateCreate }} </span>
            </div>
            <div>
              <span class="comment-text">
                {{ comment.comment }}
              </span>
            </div>
          </div>

          <b-row class="imagem">
            <b-col md="4" v-for="(attachment, rowAttachment) in comment.attachments" :key="rowAttachment">
              <base-attachment-viewer class="ml-3 mb-3" :attachment="attachment" :discard-visible="false"
                :attachmentNumber="rowAttachment + 1"></base-attachment-viewer>
            </b-col>
          </b-row>
        </div>
      </div>

      <!-- <div v-if="model.allowAttachment"> -->

      <!-- </div> -->
      <template #modal-footer="{ }">
        <div class="right">
          <b-button variant="danger" @click="onModalHide()"> Fechar </b-button>
        </div>
      </template>

      <!-- {{ model }} -->
      <!-- <div>Id: {{ filledId }}</div> -->
      <!-- <div>Status: {{ statusId }}</div> -->
    </b-modal>
    <base-dialog-confirm ref="confirm" @confirm="hideModal" @cancel="show" :message="'Sair sem salvar?'"
      :title="'Novo comentário'">
    </base-dialog-confirm>
  </b-row>
</template>
<script>
export default {
  name: "StageCommentModal",
  props: {
    filledId: Number,
    stageId: String,
    canComment: Boolean,
  },
  components: {
    BaseAttachmentViewer: () =>
      import("@/components_rms/base/BaseAttachmentViewer.vue"),
    StageNewComment: () =>
      import("@/components_rms/workflow/Stage/StageNewComment.vue"),
    BaseDialogConfirm: () =>
      import("@/components_rms/base/BaseDialogConfirm.vue"),
  },
  data() {
    return {
      canSubmit: false,
      comments: [],
      autoRefreshTime: 5000,
      newComment: {
        comment: "",
        filledId: 0,
        stageName: "",
        stageId: 0,
        attachments: [],
      },
    };
  },
  beforeDestroy: function () {
    // this.comments = [];
    // clearInterval(this.timer);
  },
  mounted: function () { },
  methods: {
    init() {
      this.timer = setInterval(this.getAllComments, this.autoRefreshTime);
    },
    show() {
      //   console.log("StageCommentModal");
      this.$refs.openModal.show();
      this.getAllComments();
    },
    getAllComments() {
      let dateFilter = null;
      if (this.comments.length > 0) {
        // dateFilter = this.dateTimeToJsonString(new Date());
        dateFilter = this.dateTimeToJsonString(
          new Date(new Date().setMinutes(new Date().getMinutes() - 10))
        );
      }

      this.$apiWorkflow
        .get(`/stage/comments/all/${this.filledId}/${dateFilter}`)
        .then((response) => {
          let comments = response.data;
          for (let comment of comments) {
            if (!this.comments.some((e) => e.id == comment.id)) {
              this.comments.unshift(comment);
            }
          }
        });
    },
    hideModal() {
      clearInterval(this.timer);
      this.comments = [];
      this.newComment.comment = "";
      this.newComment.filledId = 0;
      this.newComment.stageName = "";
      this.newComment.stageId = 0;
      this.newComment.attachments = [];
      this.$refs.openModal.hide();
    },
    onModalHide() {
      if (this.newComment.comment != "") {
        this.$refs.confirm.show();
      } else {
        this.hideModal();
      }
    },
    onModalShow() {
      this.init();
    },
  },
};
</script>
<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>
